import * as yup from "yup"
import type { RecordMedia } from "../../types"

export function initialValuesMediaDocument(media: RecordMedia | undefined, order?: number) {
  if (media) {
    if (order !== undefined) {
      return {
        ...media,
        order,
      }
    }
    return media
  }
  return {
    media: undefined,
    order: order || 0,
  }
}

export function validationSchemaMediaDocument() {
  return yup.object().shape({
    // media: yup.number().required("Campo obbligatorio"),
    order: yup.number().min(0, "Deve essere un numero positivo").required("Campo obbligatorio"),
  })
}